import SettingsConstants from 'bundles/account-settings/constants/SettingsConstants';
import { getErrorMessages, getStatusMessages } from 'bundles/user-account/utils/errorMessageUtils';

import _t from 'i18n!nls/account-settings';

const { Fields, UpdateStates } = SettingsConstants;

type FieldName = (typeof Fields)[keyof typeof Fields];

const isErrorMessageKey = (key: string): key is keyof typeof getErrorMessages => key in getErrorMessages;

export const getPasswordErrorMessage = (errorCode: string): string | undefined => {
  if (!errorCode || !isErrorMessageKey(errorCode)) return undefined;
  const msg = getErrorMessages[errorCode];
  return typeof msg === 'string' ? msg : _t('An error occurred. Please try again.');
};

export type SaveStatusMessage = {
  message: string;
  status: 'success' | 'error';
};

export const getSaveStatusMessage = (state: string): SaveStatusMessage | null => {
  switch (state) {
    case UpdateStates.SUCCEEDED:
      return { message: getStatusMessages.UPDATE_SUCCEEDED, status: 'success' };
    case UpdateStates.FAILED:
      return { message: getStatusMessages.UPDATE_FAILED, status: 'error' };
    case UpdateStates.FAILED_EMAIL_ADDRESS:
      return { message: getStatusMessages.UPDATE_FAILED_EMAIL_ADDRESS, status: 'error' };
    case UpdateStates.FAILED_NAME_MALFORMED:
      return { message: getStatusMessages.UPDATE_FAILED_NAME_MALFORMED, status: 'error' };
    case UpdateStates.FAILED_EMAIL_IN_USE:
      return { message: getStatusMessages.UPDATE_FAILED_EMAIL_IN_USE, status: 'error' };
    default:
      return null;
  }
};

export const getFieldErrorMessage = (field: FieldName): string => {
  switch (field) {
    case Fields.FULL_NAME:
      return getStatusMessages.UPDATE_FAILED_FULL_NAME;
    case Fields.EMAIL_ADDRESS:
      return getStatusMessages.UPDATE_FAILED_EMAIL_ADDRESS;
    default:
      return getStatusMessages.UPDATE_FAILED;
  }
};
